import { Fetcher, Middleware } from "openapi-typescript-fetch";
import { paths } from "./spec";

export type Wrapper = <Type>(p: Promise<Type>) => Promise<Type>;

const getCsrfTokenFromCookie = (): string | null => {
  const name = "csrftoken=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return null;
};

const useFetcher = () => {
  const fetcher = Fetcher.for<paths>();
  const headers: any = {};
  const csrfToken = getCsrfTokenFromCookie();
  if (csrfToken !== null) {
    headers["X-CSRFToken"] = csrfToken;
  }
  fetcher.configure({
    init: {
      credentials: "include",
      headers,
    },
  });
  return fetcher;
};

const errorHandlingMiddleware: Middleware = async (url, init, next) => {
  const response = await next(url, init);

  if (!response.ok) {
    throw new Error(`Request failed with status ${response.status}`);
  }

  return response;
};

const useMiddlewareFetcher = (middlewares: Middleware[] = []) => {
  const fetcher = useFetcher();
  fetcher.use(errorHandlingMiddleware);
  middlewares.forEach((middleware) => fetcher.use(middleware));
  return fetcher;
};

export const useWrappersFetcher = (wrappers: Wrapper[] = []) => {
  const middlewares = wrappers.map(
    (wrapper): Middleware =>
      async (url, init, next) =>
        wrapper(next(url, init)),
  );
  return useMiddlewareFetcher(middlewares);
};
